<template>
  <div class="user-container">
    <div class="panel-header">
      <div class="search-container">
        <div class="search-row">
          <div class="search-item">
            <label class="search-label">登录名：</label>
            <input type="text" class="search-input" v-model="searchForm.username" placeholder="请输入登录名" />
          </div>
          <div class="search-item">
            <label class="search-label">姓名：</label>
            <input type="text" class="search-input" v-model="searchForm.realName" placeholder="请输入姓名" />
          </div>
          <div class="search-item">
            <label class="search-label">所属部门：</label>
            <select class="search-select" v-model="searchForm.department">
              <option value="">全部</option>
              <option value="技术部">技术部</option>
              <option value="运营部">运营部</option>
              <option value="财务部">财务部</option>
              <option value="市场部">市场部</option>
              <option value="管理部">管理部</option>
            </select>
          </div>
          <button class="btn-search" @click="doSearch">查询</button>
          <button class="btn-reset" @click="resetSearch">重置</button>
        </div>
      </div>
      <button class="btn-add" @click="showAddAccountModal = true">
        <span class="btn-icon">+</span>
        <span>新增用户</span>
      </button>
    </div>
    <div class="table-container">
      <table class="data-table">
        <thead>
          <tr>
            <th style="width: 60px;">序号</th>
            <th style="width: 100px;">登录名</th>
            <th style="width: 100px;">姓名</th>
            <th style="width: 140px;">邮箱</th>
            <th style="width: 120px;">所属部门</th>
            <th style="width: 100px;">权限角色</th>
            <th style="width: 100px;">账号级别</th>
            <th style="width: 80px;">状态</th>
            <th style="width: 160px;">创建时间</th>
            <th style="width: 160px;">操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="account in filteredAccounts" :key="account.id">
            <td>{{ account.id }}</td>
            <td>{{ account.username }}</td>
            <td>{{ account.realName }}</td>
            <td>{{ account.email }}</td>
            <td>{{ account.department }}</td>
            <td>{{ account.role }}</td>
            <td>{{ account.accountLevel === 'county' ? '县域级' : account.accountLevel === 'scenic' ? '景区级' : '企业级' }}</td>
            <td>{{ account.status === 'active' ? '正常' : '冻结' }}</td>
            <td>{{ account.createTime }}</td>
            <td class="action-buttons">
              <button class="btn-edit" @click="editAccount(account)">
                <span>修改</span>
              </button>
              <button :class="['btn-toggle', account.status === 'active' ? 'btn-disable' : 'btn-enable']"
                @click="toggleAccountStatus(account)">
                <span>{{ account.status === 'active' ? '冻结' : '解封' }}</span>
              </button>
              <button class="btn-reset-pwd" @click="resetPassword(account)">
                <span>改密</span>
              </button>
              <button class="btn-delete" @click="deleteAccount(account.id)">
                <span>移除</span>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- 添加账号弹窗 -->
    <div class="add-account-modal" v-if="showAddAccountModal">
      <div class="modal-overlay" @click="closeAddAccountModal"></div>
      <div class="modal-content account-modal">
        <div class="modal-header">
          <div class="modal-title">{{ editingAccount ? '编辑用户信息' : '新增用户' }}</div>
          <button class="modal-close" @click="closeAddAccountModal">
            <span>×</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="form-row">
            <div class="form-item inline">
              <label class="form-label">登录名称：</label>
              <input type="text" class="form-input" v-model="accountForm.username" placeholder="请输入登录账号" />
            </div>
            <div class="form-item inline">
              <label class="form-label">真实姓名：</label>
              <input type="text" class="form-input" v-model="accountForm.realName" placeholder="请输入真实姓名" />
            </div>
          </div>
          <div class="form-row">
            <div class="form-item inline">
              <label class="form-label">密码：</label>
              <input type="password" class="form-input" v-model="accountForm.password" placeholder="请输入登录密码" />
            </div>
            <div class="form-item inline">
              <label class="form-label">确认密码：</label>
              <input type="password" class="form-input" v-model="accountForm.confirmPassword" placeholder="请再次输入密码" />
            </div>
          </div>
          <div class="form-row">
            <div class="form-item inline">
              <label class="form-label">电子邮箱：</label>
              <input type="email" class="form-input" v-model="accountForm.email" placeholder="请输入邮箱地址" />
            </div>
            <div class="form-item inline">
              <label class="form-label">手机号码：</label>
              <input type="tel" class="form-input" v-model="accountForm.phone" placeholder="请输入联系电话" />
            </div>
          </div>
          <div class="form-row">
            <div class="form-item inline">
              <label class="form-label">所属部门：</label>
              <select class="form-select" v-model="accountForm.department">
                <option value="技术部">技术部</option>
                <option value="运营部">运营部</option>
                <option value="财务部">财务部</option>
                <option value="市场部">市场部</option>
                <option value="管理部">管理部</option>
              </select>
            </div>
            <div class="form-item inline">
              <label class="form-label">权限角色：</label>
              <select class="form-select" v-model="accountForm.role">
                <option value="系统管理员">系统管理员</option>
                <option value="业务管理员">业务管理员</option>
                <option value="数据分析员">数据分析员</option>
                <option value="普通访客">普通访客</option>
                <option value="数据录入员">数据录入员</option>
                <option value="报表管理员">报表管理员</option>
              </select>
            </div>
          </div>
          <div class="form-row">
            <div class="form-item inline">
              <label class="form-label">账号状态：</label>
              <select class="form-select" v-model="accountForm.status">
                <option value="active">正常</option>
                <option value="inactive">冻结</option>
              </select>
            </div>
            <div class="form-item inline">
              <label class="form-label">账号级别：</label>
              <select class="form-select" v-model="accountForm.accountLevel">
                <option value="county">县域级</option>
                <option value="scenic">景区级</option>
                <option value="enterprise">企业级</option>
              </select>
            </div>
          </div>
          <div class="form-row">
            <div class="form-item inline">
              <label class="form-label">岗位类型：</label>
              <select class="form-select" v-model="accountForm.position">
                <option value="fulltime">全职</option>
                <option value="parttime">兼职</option>
                <option value="intern">实习</option>
              </select>
            </div>
          </div>
          <div class="form-actions">
            <button class="btn-cancel" @click="closeAddAccountModal">取消</button>
            <button class="btn-confirm" @click="saveAccount">保存</button>
          </div>
        </div>
      </div>
    </div>

    <!-- 确认操作弹窗 -->
    <div class="confirm-modal" v-if="showConfirmModal">
      <div class="modal-overlay" @click="closeConfirmModal"></div>
      <div class="modal-content confirm-modal-content">
        <div class="modal-header">
          <div class="modal-title">确认操作</div>
          <button class="modal-close" @click="closeConfirmModal">
            <span>×</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="confirm-message">{{ confirmMessage }}</div>
        </div>
        <div class="form-actions">
          <button class="btn-cancel" @click="closeConfirmModal">取消</button>
          <button class="btn-confirm btn-danger" @click="confirmAction">确定</button>
        </div>
      </div>
    </div>

    <!-- 密码重置弹窗 -->
    <div class="reset-pwd-modal" v-if="showResetPwdModal">
      <div class="modal-overlay" @click="closeResetPwdModal"></div>
      <div class="modal-content">
        <div class="modal-header">
          <div class="modal-title">重置密码</div>
          <button class="modal-close" @click="closeResetPwdModal">
            <span>×</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="form-row">
            <div class="form-item inline">
              <label class="form-label">账号：</label>
              <input type="text" class="form-input" :value="resetPwdAccount && resetPwdAccount.username" disabled />
            </div>
          </div>
          <div class="form-row">
            <div class="form-item inline">
              <label class="form-label">新密码：</label>
              <input type="password" class="form-input" v-model="newPassword" placeholder="请输入新密码" />
            </div>
          </div>
          <div class="form-row">
            <div class="form-item inline">
              <label class="form-label">确认密码：</label>
              <input type="password" class="form-input" v-model="confirmPassword" placeholder="请再次输入密码" />
            </div>
          </div>
        </div>
        <div class="form-actions">
          <button class="btn-cancel" @click="closeResetPwdModal">取消</button>
          <button class="btn-confirm" @click="doResetPassword">确定</button>
        </div>
      </div>
    </div>

    <!-- 提示弹窗 -->
    <div class="tip-modal" v-if="showTipModal">
      <div class="modal-overlay" @click="closeTipModal"></div>
      <div class="modal-content tip-modal-content">
        <div class="modal-header">
          <div class="modal-title">提示</div>
          <button class="modal-close" @click="closeTipModal">
            <span>×</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="tip-message">{{ tipMessage }}</div>
        </div>
        <div class="form-actions">
          <button class="btn-confirm" @click="closeTipModal">确定</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserManagement',
  data() {
    return {
      showAddAccountModal: false,
      editingAccount: null,
      searchForm: {
        username: '',
        realName: '',
        department: ''
      },
      originalAccounts: [],
      accountForm: {
        username: '',
        password: '',
        confirmPassword: '',
        realName: '',
        email: '',
        phone: '',
        department: '技术部',
        role: '普通员工',
        status: 'active',
        accountLevel: 'county',
        position: 'fulltime'
      },
      showConfirmModal: false,
      confirmMessage: '',
      confirmCallback: null,
      showResetPwdModal: false,
      resetPwdAccount: null,
      newPassword: '',
      confirmPassword: '',
      showTipModal: false,
      tipMessage: '',
      accounts: [
        { id: 1, username: 'zhangwei', realName: '张伟', email: 'zhangwei@company.com', phone: '13800138001', department: '管理部', role: '系统管理员', status: 'active', accountLevel: 'county', position: 'fulltime', createTime: '2026-06-09 10:30:00' },
        { id: 2, username: 'lili', realName: '李丽', email: 'lili@company.com', phone: '13800138002', department: '技术部', role: '部门主管', status: 'active', accountLevel: 'scenic', position: 'fulltime', createTime: '2026-06-09 14:20:00' },
        { id: 3, username: 'wangqiang', realName: '王强', email: 'wangqiang@company.com', phone: '13800138003', department: '运营部', role: '普通员工', status: 'active', accountLevel: 'enterprise', position: 'fulltime', createTime: '2026-06-09 09:15:00' },
        { id: 4, username: 'chenyue', realName: '陈悦', email: 'chenyue@company.com', phone: '13800138004', department: '市场部', role: '普通员工', status: 'inactive', accountLevel: 'scenic', position: 'parttime', createTime: '2026-06-09 16:45:00' },
        { id: 5, username: 'lihua', realName: '李华', email: 'lihua@company.com', phone: '13800138005', department: '财务部', role: '普通员工', status: 'active', accountLevel: 'county', position: 'fulltime', createTime: '2026-06-09 11:00:00' },
        { id: 6, username: 'zhaoming', realName: '赵明', email: 'zhaoming@company.com', phone: '13800138006', department: '技术部', role: '外部访客', status: 'active', accountLevel: 'enterprise', position: 'intern', createTime: '2026-06-10 08:30:00' }
      ]
    }
  },
  mounted() {
    this.originalAccounts = JSON.parse(JSON.stringify(this.accounts))
  },
  computed: {
    filteredAccounts() {
      return this.accounts.filter(account => {
        const matchUsername = !this.searchForm.username || account.username.toLowerCase().includes(this.searchForm.username.toLowerCase())
        const matchRealName = !this.searchForm.realName || account.realName.toLowerCase().includes(this.searchForm.realName.toLowerCase())
        const matchDepartment = !this.searchForm.department || account.department === this.searchForm.department
        return matchUsername && matchRealName && matchDepartment
      })
    }
  },
  methods: {
    doSearch() {
      if (!this.originalAccounts.length) {
        this.originalAccounts = JSON.parse(JSON.stringify(this.accounts))
      }
    },
    resetSearch() {
      this.searchForm = {
        username: '',
        realName: '',
        department: ''
      }
    },
    editAccount(account) {
      this.editingAccount = account
      this.accountForm = {
        username: account.username,
        password: '',
        confirmPassword: '',
        realName: account.realName,
        email: account.email,
        phone: account.phone,
        department: account.department,
        role: account.role,
        status: account.status,
        accountLevel: account.accountLevel || 'county',
        position: account.position || 'fulltime'
      }
      this.showAddAccountModal = true
    },
    closeAddAccountModal() {
      this.showAddAccountModal = false
      this.editingAccount = null
      this.accountForm = {
        username: '',
        password: '',
        confirmPassword: '',
        realName: '',
        email: '',
        phone: '',
        department: '技术部',
        role: '普通员工',
        status: 'active',
        accountLevel: 'county',
        position: 'fulltime'
      }
    },
    saveAccount() {
      if (!this.accountForm.username) {
        this.showTipMessage('请输入登录名称')
        return
      }
      if (!this.accountForm.realName) {
        this.showTipMessage('请输入真实姓名')
        return
      }
      if (!this.editingAccount && !this.accountForm.password) {
        this.showTipMessage('请输入密码')
        return
      }
      if (this.accountForm.password && this.accountForm.password !== this.accountForm.confirmPassword) {
        this.showTipMessage('两次输入的密码不一致')
        return
      }

      if (this.editingAccount) {
        const index = this.accounts.findIndex(a => a.id === this.editingAccount.id)
        if (index !== -1) {
          this.accounts[index] = {
            ...this.accounts[index],
            username: this.accountForm.username,
            realName: this.accountForm.realName,
            email: this.accountForm.email,
            phone: this.accountForm.phone,
            department: this.accountForm.department,
            role: this.accountForm.role,
            status: this.accountForm.status,
            accountLevel: this.accountForm.accountLevel,
            position: this.accountForm.position
          }
          if (this.accountForm.password) {
            this.accounts[index].password = this.accountForm.password
          }
        }
      } else {
        const newId = Math.max(...this.accounts.map(a => a.id)) + 1
        this.accounts.push({
          id: newId,
          username: this.accountForm.username,
          password: this.accountForm.password,
          realName: this.accountForm.realName,
          email: this.accountForm.email,
          phone: this.accountForm.phone,
          department: this.accountForm.department,
          role: this.accountForm.role,
          status: this.accountForm.status,
          accountLevel: this.accountForm.accountLevel,
          position: this.accountForm.position,
          createTime: new Date().toLocaleString('zh-CN')
        })
      }

      this.closeAddAccountModal()
      this.showTipMessage(this.editingAccount ? '修改成功' : '新增成功')
    },
    deleteAccount(id) {
      const account = this.accounts.find(a => a.id === id)
      this.showConfirmModalFn(`确定要移除人员 "${account && account.realName}" 吗？`, () => {
        this.accounts = this.accounts.filter(a => a.id !== id)
        this.showTipMessage('移除成功')
      })
    },
    toggleAccountStatus(account) {
      const action = account.status === 'active' ? '冻结' : '解封'
      this.showConfirmModalFn(`确定要${action}人员 "${account.realName}" 吗？`, () => {
        account.status = account.status === 'active' ? 'inactive' : 'active'
        this.showTipMessage(`${action}成功`)
      })
    },
    resetPassword(account) {
      this.resetPwdAccount = account
      this.newPassword = ''
      this.confirmPassword = ''
      this.showResetPwdModal = true
    },
    doResetPassword() {
      if (!this.newPassword.trim()) {
        this.showTipMessage('请输入新密码')
        return
      }
      if (this.newPassword !== this.confirmPassword) {
        this.showTipMessage('两次输入的密码不一致')
        return
      }

      if (this.resetPwdAccount) {
        this.resetPwdAccount.password = this.newPassword
        this.closeResetPwdModal()
        this.showTipMessage('密码重置成功')
      }
    },
    showConfirmModalFn(message, callback) {
      this.confirmMessage = message
      this.confirmCallback = callback
      this.showConfirmModal = true
    },
    closeConfirmModal() {
      this.showConfirmModal = false
      this.confirmMessage = ''
      this.confirmCallback = null
    },
    confirmAction() {
      if (this.confirmCallback) {
        this.confirmCallback()
      }
      this.closeConfirmModal()
    },
    closeResetPwdModal() {
      this.showResetPwdModal = false
      this.resetPwdAccount = null
      this.newPassword = ''
      this.confirmPassword = ''
    },
    showTipMessage(message) {
      this.tipMessage = message
      this.showTipModal = true
    },
    closeTipModal() {
      this.showTipModal = false
      this.tipMessage = ''
    }
  }
}
</script>

<style scoped>
.user-container {
  --ui-bg: #f5f7fa;
  --ui-surface: #ffffff;
  --ui-surface-soft: #f9fafc;
  --ui-border: #dcdfe6;
  --ui-border-soft: #ebeef5;
  --ui-text: #1f2937;
  --ui-text-regular: #606266;
  --ui-primary: #409eff;
  --ui-success: #67c23a;
  --ui-danger: #f56c6c;
  --ui-warning: #e6a23c;
  --ui-radius: 8px;
  --ui-shadow: 0 8px 24px rgba(31, 45, 61, 0.08);
  
  min-height: calc(100vh - 54px);
  background: var(--ui-bg);
  padding: 24px;
  box-sizing: border-box;
}

.panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  margin-bottom: 16px;
  padding-bottom: 14px;
}

.search-container {
  flex: 1;
}

.search-row {
  display: flex;
  align-items: center;
  gap: 16px;
}

.search-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.search-label {
  font-size: 13px;
  color: var(--ui-text-regular);
}

.search-input,
.search-select {
  padding: 8px 12px;
  background: var(--ui-surface);
  border: 1px solid var(--ui-border);
  border-radius: 6px;
  color: var(--ui-text);
  font-size: 13px;
  min-width: 140px;
}

.btn-search,
.btn-reset {
  min-height: 32px;
  padding: 0 16px;
  border: 1px solid var(--ui-border);
  border-radius: 6px;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: none;
}

.btn-search {
  background: #ecf5ff;
  border-color: #b3d8ff;
  color: #1d4f91;
}

.btn-search:hover {
  background: rgba(64, 158, 255, 0.15);
}

.btn-reset {
  background: var(--ui-surface-soft);
  color: var(--ui-text-regular);
}

.btn-reset:hover {
  background: rgba(0, 0, 0, 0.05);
}

.panel-title {
  display: flex;
  align-items: center;
  gap: 10px;
}

.title-icon {
  font-size: 24px;
}

.panel-title h2 {
  margin: 0;
  color: var(--ui-text);
  font-size: 20px;
}

.btn-add {
  display: flex;
  align-items: center;
  gap: 6px;
  min-height: 32px;
  padding: 0 14px;
  background: #ecf5ff;
  border: 1px solid #b3d8ff;
  border-radius: 6px;
  color: #1d4f91;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: none;
}

.btn-add:hover {
  background: rgba(64, 158, 255, 0.15);
}

.btn-icon {
  font-size: 16px;
}

.table-container {
  background: rgba(255, 255, 255, 0.96);
  border: 1px solid var(--ui-border-soft);
  border-radius: var(--ui-radius);
  box-shadow: var(--ui-shadow);
  overflow: hidden;
  padding: 18px;
  box-sizing: border-box;
}

.table-container * {
  text-shadow: none;
}

.table-container,
.table-container p,
.table-container span,
.table-container div {
  color: var(--ui-text-regular, #606266);
}

.data-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}

.data-table th,
.data-table td {
  min-height: 36px;
  padding: 10px 12px;
  text-align: left;
  border-bottom: 1px solid var(--ui-border-soft, #ebeef5);
}

.data-table tr:last-child td {
  border-bottom: 0;
}

.data-table th {
  background: var(--ui-surface-soft);
  color: var(--ui-text);
  font-weight: 600;
  font-size: 13px;
}

.data-table tbody tr:hover {
  background: #ecf5ff;
}

.data-table td {
  color: var(--ui-text);
  font-size: 13px;
}

.status-badge {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
}

.status-active {
  background: #f0f9eb;
  color: var(--ui-success);
  border: 1px solid #e1f3d8;
}

.status-inactive {
  background: var(--ui-surface-soft);
  color: var(--ui-text-regular);
  border: 1px solid var(--ui-border-soft);
}

.action-buttons {
  display: flex;
  gap: 8px;
}

.btn-edit,
.btn-toggle,
.btn-reset-pwd,
.btn-delete {
  min-height: 32px;
  padding: 0 14px;
  border: 1px solid var(--ui-border);
  border-radius: 6px;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s;
  background: var(--ui-surface-soft);
  color: var(--ui-text-regular);
  box-shadow: none;
}

.btn-edit {
  color: var(--ui-primary);
}

.btn-edit:hover {
  background: rgba(64, 158, 255, 0.1);
}

.btn-toggle.btn-enable {
  background: #f0f9eb;
  color: var(--ui-success);
  border-color: #e1f3d8;
}

.btn-toggle.btn-enable:hover {
  background: rgba(103, 194, 58, 0.15);
}

.btn-toggle.btn-disable {
  background: #fef0f0;
  color: var(--ui-danger);
  border-color: #fde2e2;
}

.btn-toggle.btn-disable:hover {
  background: rgba(245, 108, 108, 0.15);
}

.btn-reset-pwd {
  color: var(--ui-warning);
  border-color: #f5dab1;
  background: #fdf6ec;
}

.btn-reset-pwd:hover {
  background: rgba(230, 162, 60, 0.15);
}

.btn-delete {
  background: #fef0f0;
  color: var(--ui-danger);
  border-color: #fde2e2;
}

.btn-delete:hover {
  background: rgba(245, 108, 108, 0.15);
}

/* 弹窗样式 */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(31, 45, 61, 0.28);
  z-index: 1000;
}

.modal-content {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #ffffff;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  z-index: 1001;
  width: fit-content;
  min-width: 480px;
  max-width: 90vw;
  max-height: 90vh;
  overflow-y: auto;
  padding: 18px;
  box-sizing: border-box;
}

.modal-content * {
  text-shadow: none;
}

.modal-content,
.modal-content p,
.modal-content span,
.modal-content div {
  color: var(--ui-text-regular, #606266);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 0;
  border-bottom: 1px solid var(--ui-border-soft);
}

.modal-title {
  font-size: 18px;
  font-weight: 600;
  color: var(--ui-text);
}

.modal-close {
  width: 32px;
  height: 32px;
  border: none;
  background: transparent;
  color: #999;
  font-size: 24px;
  cursor: pointer;
  border-radius: 4px;
  transition: color 0.2s;
}

.modal-close:hover {
  background: rgba(0, 0, 0, 0.05);
}

.modal-body {
  padding: 20px 0;
}

.form-row {
  display: flex;
  gap: 20px;
  margin-bottom: 16px;
}

.form-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.form-item.inline {
  flex-direction: row;
  align-items: center;
  gap: 10px;
}

.form-item.inline .form-label {
  flex-shrink: 0;
  width: 80px;
  white-space: nowrap;
  text-align: right;
}

.form-item.inline .form-input,
.form-item.inline .form-select {
  flex: 1;
  min-width: 0;
}

.form-item.full-width {
  flex: 1;
  min-width: 100%;
}

.form-label {
  font-size: 13px;
  color: var(--ui-text-regular);
}

.form-input,
.form-select {
  padding: 10px 12px;
  background: var(--ui-surface);
  border: 1px solid var(--ui-border);
  border-radius: 6px;
  color: var(--ui-text);
  font-size: 14px;
}

.form-textarea {
  padding: 10px 12px;
  background: var(--ui-surface);
  border: 1px solid var(--ui-border);
  border-radius: 6px;
  color: var(--ui-text);
  font-size: 14px;
  min-height: 80px;
  resize: vertical;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
}

.btn-cancel {
  min-height: 32px;
  padding: 0 14px;
  background: transparent;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  color: #666;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-cancel:hover {
  border-color: #999;
}

.btn-confirm {
  min-height: 32px;
  padding: 0 14px;
  background: #409eff;
  border: none;
  border-radius: 4px;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-confirm:hover {
  background: #67b8ff;
}

.btn-confirm.btn-danger {
  background: #f56c6c;
  color: #fff;
}

.btn-confirm.btn-danger:hover {
  background: #f78989;
}

.reset-pwd-info {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
}

.reset-pwd-info span {
  color: var(--ui-text-regular);
  font-size: 14px;
}

.reset-pwd-username {
  font-weight: 600;
  color: var(--ui-primary) !important;
}

.confirm-message,
.tip-message {
  color: var(--ui-text);
  font-size: 15px;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/pages/user.vue